import Image from "next/image";
import { Heading } from "../atoms/Heading";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { cn } from "../lib/utils";
import { Paragraph } from "../atoms/Paragraph";

export type FAQItem = {
  id: string;
  question: string;
  answer: string;
};

export type FAQSectionProps = {
  title: string;
  subtitle: string;
  items: FAQItem[];
  image: string;
  className?: string;
};

export function FAQSection({
  title,
  subtitle,
  items,
  image,
  className,
}: FAQSectionProps) {
  return (
    <section className={cn("w-full bg-background py-10", className)}>
      <div className="mx-auto flex  w-full max-w-7xl flex-col gap-4 px-6 md:px-12">
        <div className="space-y-4 text-center ">
          <Heading as="h2" className="text-4xl md:text-5xl font-bold text-text">
            {title.split(" ").slice(0, -1).join(" ")}{" "}
            <span className="text-secondary">{title.split(" ").slice(-1)}</span>
          </Heading>
          <Paragraph>{subtitle}</Paragraph>
        </div>

        <div className="grid grid-cols-1 gap-10 2xl:grid-cols-2 2xl:items-start">
          <div className="space-y-4">
            <Accordion type="single" collapsible className="w-full space-y-6">
              {items.map((item) => (
                <AccordionItem
                  key={item.id}
                  value={String(item.id)}
                  className="rounded-2xl border-0"
                >
                  <AccordionTrigger
                    className="
          group rounded-2xl bg-muted px-8 py-6
          text-left text-xl font-semibold 
          [&>svg]:hidden
          flex justify-between items-center gap-4
        "
                  >
                    <span className="hover:no-underline flex-1">
                      {item.question}
                    </span>

                    {/* BOUTON ICÔNE */}
                    <span className="grid size-12 place-items-center rounded-full bg-secondary text-white transition-transform group-data-[state=open]:rotate-180 shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="size-6"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </span>
                  </AccordionTrigger>

                  <AccordionContent className="rounded-b-2xl bg-white px-8 text-lg text-muted-foreground">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

          </div>
          <div className="hidden 2xl:flex 2xl:justify-end">
            <Image
              src={image}
              alt={title}
              width={640}
              height={647}
              className="h-auto w-full max-w-[640px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
